import React from 'react';
import { FormattedMessage, defineMessages } from 'react-intl';

import { useAnalyticsEvents } from '@atlaskit/analytics-next/useAnalyticsEvents';

import { WarningModal } from '../../Modals/WarningModal.tsx';
import { i18n as commonErrorModalI18n } from '../../Modals/CommonErrorModal.tsx';

export const i18n: {
	noAccess: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	noPermissions: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	noAccessCommon: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	noPermissionsCommon: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	noAccess: {
		id: 'import-from-sources.import-from-onedrive.no-access',
		defaultMessage: 'We couldn’t open the file',
		description:
			"Message in modal header indicating that the user doesn't have access to get the file",
	},
	noPermissions: {
		id: 'import-from-sources.import-from-onedrive.no-permission',
		defaultMessage:
			'You may not have permission to access the file, or the file may not exist anymore.',
		description:
			'Message in modal body indicating that might not have enough permission to get the requested file',
	},
	noAccessCommon: {
		id: 'import-from-sources.import-from-onedrive.noAccessCommon',
		defaultMessage: 'One or more of the files couldn’t be opened',
		description:
			"Message in modal header indicating that the user doesn't have access to get the files",
	},
	noPermissionsCommon: {
		id: 'import-from-sources.import-from-onedrive.noPermissionsCommon',
		defaultMessage:
			'You may not have permission to access the files, or they may not exist anymore.',
		description:
			'Message in modal body indicating that might not have enough permission to get the requested files',
	},
});

export const PermissionWarningModal: React.FC<{
	onSubmit: () => void;
	onClose: () => void;
}> = ({ onSubmit, onClose }) => {
	const { createAnalyticsEvent } = useAnalyticsEvents();

	const handleCloseClick = () => {
		createAnalyticsEvent({
			type: 'sendUIEvent',
			data: {
				source: 'office365PermissionWarningModal',
				action: 'dismissed',
				actionSubject: 'button',
				actionSubjectId: 'closeWarningModal',
			},
		}).fire();
		onClose();
	};

	const handleSubmitClick = () => {
		createAnalyticsEvent({
			type: 'sendUIEvent',
			data: {
				source: 'office365PermissionWarningModal',
				action: 'clicked',
				actionSubject: 'button',
				actionSubjectId: 'office365selectDifferentDoc',
			},
		}).fire();
		onSubmit();
	};

	return (
		<WarningModal
			onSubmit={handleSubmitClick}
			onClose={handleCloseClick}
			headText={<FormattedMessage {...i18n.noAccessCommon} />}
			bodyText={<FormattedMessage {...i18n.noPermissionsCommon} />}
			submitText={
				<FormattedMessage {...commonErrorModalI18n.tryDifferentDocumentsUploadErrorPopupButton} />
			}
		/>
	);
};
